module.exports = __webpack_public_path__ + "static/media/logo.f7ba6a5c.svg";